import React from 'react';
import { useState } from 'react';
import { MFPriceChart } from './MFPriceChart';
import { SCHEME_CHART_DURARION_LEVELS } from '@/src/common/enum';
import { MutualFundsPeriodChips } from '../../blocks/MutualFundsPeriodChips';
import styled from 'styled-components';

interface ChartDetailsProps {
  cocode: string | null;
  schemeReturns: Record<SCHEME_CHART_DURARION_LEVELS, number | string>;
  inception: number | string;
}

const NAVRETURNS = styled.p<{ positive: boolean }>`
  padding: 0 0 0 1rem;
  font-weight: 600;
  color: ${(props: { positive: boolean }) =>
    props.positive ? 'green' : 'red'};
`;

export const ChartDetails: React.FC<ChartDetailsProps> = ({
  cocode,
  schemeReturns,
  inception,
}) => {
  const [periodLevel, setPeriodLevel] = useState<string>(
    SCHEME_CHART_DURARION_LEVELS.ONEYEAR,
  );

  const handlePeriodSelect = (period: string) => {
    setPeriodLevel(period);
  };
  /* eslint-disable sonarjs/different-types-comparison */
  const schemeReturnsValue =
    // eslint-disable-next-line sonarjs/expression-complexity
    schemeReturns[periodLevel as SCHEME_CHART_DURARION_LEVELS] !== undefined &&
    schemeReturns[periodLevel as SCHEME_CHART_DURARION_LEVELS] !== null &&
    schemeReturns[periodLevel as SCHEME_CHART_DURARION_LEVELS] !== '-'
      ? schemeReturns[periodLevel as SCHEME_CHART_DURARION_LEVELS]
      : (inception ?? 0);
  /* eslint-disable sonarjs/different-types-comparison */
  const isPositive =
    typeof schemeReturnsValue === 'number' && schemeReturnsValue > 0;

  return (
    <div>
      <NAVRETURNS positive={isPositive}>
        {typeof schemeReturnsValue === 'number'
          ? `${schemeReturnsValue.toFixed(2)}%`
          : '-'}
      </NAVRETURNS>
      <div style={{ width: '100%' }}>
        <MFPriceChart periodLevel={periodLevel} cocode={cocode} />
        <MutualFundsPeriodChips
          periodData={Object.values(SCHEME_CHART_DURARION_LEVELS)}
          onPeriodSelect={handlePeriodSelect}
          defaultLabel={3}
        />
      </div>
    </div>
  );
};
